import type { CityConfig } from "../city-template/types";

export const madisonALConfig: CityConfig = {
  city: "Madison",
  state: "Alabama",
  stateAbbr: "AL",
  slug: "madison-al",
  route: "/cities/madison-al",
  title: "Emergency Passport Madison, AL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Madison, AL — as fast as 24 hours. Serving Huntsville metro professionals and Madison County. A+ BBB rated registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Madison, AL",
  heroSubtitle: "Defense contractor trip to London with one week notice? Family vacation to Japan and your passport expired? Dublin Park soccer tournament in Canada need fast documents? We help Madison residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20suburban%20townscape%20of%20Madison%20Alabama%20with%20Dublin%20Park%20green%20spaces%20Rainbow%20Mountain%20trails%20modern%20residential%20neighborhoods%20Huntsville%20metro%20skyline%20on%20horizon%20lush%20greenery%20sunny%20afternoon%20light%20professional%20photography%20soft%20Southern%20atmosphere&width=1800&height=700&seq=madison-al-hero-2026&orientation=landscape",
  heroImageAlt: "Madison Alabama suburban townscape with Dublin Park at sunny afternoon",
  geoPosition: "34.7092;-86.7396",
  geoPlacename: "Madison, Alabama",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 200 miles southeast of Madison via I-65/I-20",
  },
  nearbyCitiesZips: [
    { name: "Madison", zips: "35756, 35757, 35758" },
    { name: "Huntsville", zips: "35801, 35802, 35803" },
    { name: "Harvest", zips: "35749" },
    { name: "Meridianville", zips: "35759" },
    { name: "Monrovia", zips: "35806" },
    { name: "Athens", zips: "35611, 35613" },
    { name: "Decatur", zips: "35601, 35603" },
    { name: "Owens Cross Roads", zips: "35763" },
    { name: "Hazel Green", zips: "35750" },
    { name: "Ardmore", zips: "35739" },
    { name: "Elkmont", zips: "35620" },
    { name: "Hartselle", zips: "35640" },
    { name: "Fayetteville", zips: "37334" },
    { name: "Ardmore", zips: "38449" },
    { name: "Pulaski", zips: "38478" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Huntsville metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Huntsville Metro", desc: "Serving Madison, Huntsville, Harvest, and the technology corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Huntsville, AL", route: "/cities/huntsville" },
    { name: "Fast passport renewal in Decatur, AL", route: "/cities/decatur-al" },
    { name: "Emergency passport help in Birmingham, AL", route: "/cities/birmingham" },
    { name: "Urgent passport services in Atlanta, GA", route: "/cities/atlanta" },
    { name: "Same-day passport help in Nashville, TN", route: "/cities/nashville" },
    { name: "Passport courier services in Montgomery, AL", route: "/cities/montgomery-al" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Madison remotely via secure courier. We do not have a walk-in office in Madison — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Madison County and the Huntsville metro.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Madison County and the Huntsville metro including Limestone and Morgan counties",
  serviceAreaIntro: "From the technology corridors and Dublin Park in Madison to the Rocket City skyline of Huntsville, from the growing communities of Harvest and Meridianville to the historic streets of Athens, from the Tennessee River valley of Decatur to the suburban neighborhoods of Monrovia — Fast Passport Center serves the entire Huntsville metro area. We regularly help travelers from Madison County and surrounding areas get their passports fast without the 200-mile drive to Atlanta.",
  nearbyCitiesIntro: "We serve all Madison neighborhoods and the surrounding Huntsville metro including Huntsville, Harvest, Meridianville, Monrovia, Athens, and Decatur. If you are anywhere in Madison County, Limestone County, or the Tennessee Valley, we have you covered.",
  howItWorksIntro: "Most Madison travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Madison travelers often face a 3+ hour drive to the nearest regional passport agency in Atlanta. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Madison and Huntsville metro travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Madison? Here are the most common ones we hear from Huntsville metro travelers.",
  statePageRoute: "/states/alabama",
  statePageName: "Alabama",
  dmvWebsite: "https://www.alea.gov/driver-license",
  dmvLabel: "AL Law Enforcement Agency — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Madison travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Cynthia D.",
      location: "Madison, AL",
      rating: 5,
      text: "Defense contractor trip to Japan in 5 days. My passport had expired and I didn't realize it. Fast Passport Center got me renewed in 28 hours. Madison to Tokyo without leaving my home office. Incredible service!",
      service: "Passport Renewal",
    },
    {
      name: "Greg H.",
      location: "Harvest, AL",
      rating: 5,
      text: "Family medical emergency in London. Fast Passport Center got our entire family's passports in 26 hours. The dedicated agent was calm, fast, and professional. Saved our family trip when we needed it most.",
      service: "Emergency Passport",
    },
    {
      name: "Lauren W.",
      location: "Madison, AL",
      rating: 5,
      text: "Three kids needed passports for a summer exchange to Germany. Fast Passport Center handled all three child applications perfectly. All done in 5 days. Madison families should know about this service!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "madison-al-1",
      name: "Madison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "56 Hughes Rd",
      city: "Madison",
      state: "AL",
      zip: "35758",
      phone: "(256) 461-8008",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Madison facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "madison-al-2",
      name: "Huntsville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3401 Wall Triana Hwy SW",
      city: "Huntsville",
      state: "AL",
      zip: "35813",
      phone: "(256) 464-9931",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles east of Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest regional facility. Serves Huntsville and Madison County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "madison-al-3",
      name: "Madison County Service Center",
      type: "County Service Center Passport Acceptance",
      address: "100 Northside Square",
      city: "Huntsville",
      state: "AL",
      zip: "35801",
      phone: "(256) 532-3493",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "15 miles east of Madison",
      website: "https://www.madisoncountyal.gov",
      websiteLabel: "Madison County Service Center",
      notes: "Accepts passport applications at the county service center. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "madison-al-4",
      name: "Athens Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "615 S Clinton St",
      city: "Athens",
      state: "AL",
      zip: "35611",
      phone: "(256) 232-1920",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Athens and Limestone County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "madison-al-5",
      name: "Decatur Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 Well St NE",
      city: "Decatur",
      state: "AL",
      zip: "35601",
      phone: "(256) 353-7500",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles southwest of Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Decatur and Morgan County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Madison photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Madison County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Madison applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Atlanta regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Huntsville metro families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Madison travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Madison." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Madison address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Madison before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Madison for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5-hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Madison?", a: "Fast Passport Center offers fast passport renewal in Madison in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Madison?", a: "The nearest regional passport agency to Madison is the Atlanta Passport Agency, approximately 200 miles southeast via I-65/I-20. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Madison without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Madison?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 3.5 hours from Madison — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Madison County and Huntsville metro residents." },
    { q: "Do you serve the entire Huntsville metro area?", a: "Absolutely. Fast Passport Center serves the entire Huntsville metro including Madison, Huntsville, Harvest, Meridianville, Monrovia, and surrounding areas. Our courier service works seamlessly from any address in Madison County, Limestone County, or Morgan County." },
    { q: "Can I expedite a child passport in Madison?", a: "Yes. Fast Passport Center expedites child passports in Madison for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Huntsville metro families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Madison with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Madison", address: "8650 Madison Blvd, Madison, AL 35758", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Madison", address: "99 Hughes Rd, Madison, AL 35758", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Madison", address: "8100 Highway 72 W, Madison, AL 35758", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Huntsville", address: "330 Sutton Rd NW, Huntsville, AL 35763", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "ALEA Driver License Office — Huntsville",
      address: "1115-D Church St NW, Huntsville, AL 35801",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Primary ALEA office for Madison County. Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "ALEA Driver License Office — Athens",
      address: "22035 US Highway 72, Athens, AL 35611",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Limestone County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "ALEA Driver License Office — Decatur",
      address: "2411 Highway 31 S, Decatur, AL 35603",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Morgan County. REAL ID available.",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { title: "Birth Certificates", description: "Request certified Alabama birth certificates from ADPH Vital Records. Available by mail, online, or in person at the Montgomery office.", link: "https://www.alabamapublichealth.gov/vitalrecords/birth-certificates.html", icon: "ri-user-heart-line" },
    { title: "Death Certificates", description: "Obtain certified Alabama death certificates through the ADPH Center for Health Statistics. Mail, online, and in-person options available.", link: "https://www.alabamapublichealth.gov/vitalrecords/death-certificates.html", icon: "ri-file-history-line" },
    { title: "Marriage Certificates", description: "Marriage certificates from 1936–present available through ADPH. Earlier records held by the Madison County Probate Judge at 100 Northside Square, Huntsville, AL 35801.", link: "https://www.alabamapublichealth.gov/vitalrecords/marriage-certificates.html", icon: "ri-hearts-line" },
    { title: "Divorce Certificates", description: "Divorce records from 1950–present available through ADPH. For certified divorce decrees, contact the Madison County Circuit Clerk at 100 Northside Square, Huntsville.", link: "https://www.alabamapublichealth.gov/vitalrecords/divorce-certificates.html", icon: "ri-file-copy-2-line" },
    { title: "Order Online — VitalChek", description: "Order Alabama birth, death, marriage, and divorce certificates online through VitalChek, the official partner of the Alabama Department of Public Health. Fastest online option.", link: "https://www.vitalchek.com/", icon: "ri-global-line" },
  ],
  airports: [
    {
      code: "HSV",
      name: "Huntsville International Airport",
      distance: "8 miles east of Madison",
      address: "1000 Glenn Hearn Blvd SW, Huntsville, AL 35824",
      note: "Major North Alabama airport with direct flights to hubs nationwide. About 15 minutes from Madison.",
      flightUrl: "https://www.flyhuntsville.com/",
      flightLabel: "HSV Airport",
      featured: true,
    },
    {
      code: "BHM",
      name: "Birmingham-Shuttlesworth International Airport",
      distance: "95 miles south of Madison",
      address: "5900 Messer Airport Hwy, Birmingham, AL 35212",
      note: "Major Alabama airport with direct flights nationwide. About 1 hour 30 minutes from Madison.",
      flightUrl: "https://www.flybirmingham.com/",
      flightLabel: "BHM Airport",
      featured: false,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "110 miles north of Madison",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Major Tennessee airport with extensive direct flights. About 1 hour 50 minutes from Madison.",
      flightUrl: "https://flynashville.com/",
      flightLabel: "BNA Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
};